// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"eb999f89","404":"6264e994","463":"4f54f1aa","598":"d146f37c","744":"5699714d","787":"1c7a3ac1"}[chunkId] + ".chunk.js";
};